export class PresentLoaderSuccess {
  public static readonly type = '[Loader] PresentLoaderSuccess';
}
